import baseControllerInput from './baseControllerInput'
import { CHARACTER_NAME_REGEX } from 'core/constants/regex'
import { REQUIRED_ERROR_MESSAGE } from 'messages'

function buildControllerName({
  input,
  maxLength,
  errorMessage = 'Please enter a valid first name.'
}) {
  let optional = false
  const baseController = baseControllerInput({
    getErrorMessage: state => {
      if (optional) {
        return ''
      }

      const value = state.input.value.trim()
      if (value.length === 0) {
        return REQUIRED_ERROR_MESSAGE
      }

      const isValid =
        value.length > 1 &&
        (typeof maxLength === 'undefined' ? true : value.length <= maxLength)

      return isValid ? '' : errorMessage
    },
    maskConfig: {
      mask: (rawValue = '') => {
        return rawValue.split('').map(() => CHARACTER_NAME_REGEX)
      },
      guide: false
    }
  })({ input })

  baseController.makeOptional = () => {
    optional = true
    baseController.validate()
  }

  const getStatus = baseController.getStatus
  baseController.getStatus = () => {
    const { valid, value } = getStatus()

    return {
      valid: optional && value.length === 0 ? true : valid,
      value
    }
  }

  return baseController
}

export default buildControllerName
